import { render, staticRenderFns } from "./userConfirmAction.vue?vue&type=template&id=00dea50e&lang=pug"
import script from "./userConfirmAction.vue?vue&type=script&lang=js"
export * from "./userConfirmAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports